import { graphql } from "gql.tada";

export const createProductMut = graphql(`
  mutation createProduct($input: CreateProductStateInput!) {
    createProduct(input: $input) {
      result {
        product {
          id
          orderCode {
            parts {
              options {
                signatures {
                  description
                  value
                  range
                  isDefault
                  state
                  key
                  title
                  presentation
                }
                currentSignature {
                  description
                  value
                  range
                  isDefault
                  state
                  key
                  title
                  presentation
                }
                state
                range {
                  min
                  max
                }
                type
                separator
                key
                title
                presentation
              }
              state
              key
              title
              presentation
            }
            key
            title
            presentation
          }
          selectedAccessories {
            seriesId
            pimId
            seriesName
            currentPresentation
            currentStrategyId
            ordercode {
              parts {
                options {
                  signatures {
                    description
                    value
                    range
                    isDefault
                    state
                    key
                    title
                    presentation
                  }
                  currentSignature {
                    description
                    value
                    range
                    isDefault
                    state
                    key
                    title
                    presentation
                  }
                  state
                  range {
                    min
                    max
                  }
                  type
                  separator
                  key
                  title
                  presentation
                }
                state
                key
                title
                presentation
              }
              key
              title
              presentation
            }
            accessoryId
            accessoryGroupId
            infoText
            optionStates {
              partKey
              optionKey
              signatureKey
              signaturePresentation
              parentRef {
                partKey
                optionKey
              }
              isSizePart
              signatureValue

              separator
            }
            lastChange {
              partKey
              optionKey
              signatureKey
              parentRef {
                partKey
                optionKey
              }
              isSizePart
              signatureValue

              separator
            }
          }
          accessoryGroups {
            id
            name
            accessories {
              seriesId
              pimId
              seriesName
              serieAlias
              currentPresentation
              currentStrategyId
              ordercode {
                parts {
                  options {
                    signatures {
                      description
                      value
                      range
                      isDefault
                      state
                      key
                      title
                      presentation
                    }
                    currentSignature {
                      description
                      value
                      range
                      isDefault
                      state
                      key
                      title
                      presentation
                    }
                    state
                    range {
                      min
                      max
                    }
                    type
                    separator
                    key
                    title
                    presentation
                  }
                  state
                  key
                  title
                  presentation
                }
                key
                title
                presentation
              }
              accessoryId
              accessoryGroupId
              infoText
              optionStates {
                partKey
                optionKey
                signatureKey
                signaturePresentation
                parentRef {
                  partKey
                  optionKey
                }
                isSizePart
                signatureValue

                separator
              }
              lastChange {
                partKey
                optionKey
                signatureKey
                parentRef {
                  partKey
                  optionKey
                }
                isSizePart
                signatureValue

                separator
              }
            }
          }
          accessoryInfo {
            accessoryId
            accessoryGroupId
            parent {
              seriesId
              state {
                currentStrategyId
                currentStrategyName
                orderCodeState {
                  optionStates {
                    isSizePart
                    optionKey
                    partKey
                    separator
                    signatureKey
                    signatureValue
                    signaturePresentation
                    parentRef {
                      partKey
                      optionKey
                    }
                  }
                  lastChange {
                    isSizePart
                    optionKey
                    partKey
                    separator
                    signatureKey
                    signatureValue
                    signaturePresentation
                    parentRef {
                      partKey
                      optionKey
                    }
                  }
                }
                propertyStates {
                  id
                  value
                }
              }
            }
          }
          inputs {
            presentation
            properties {
              id
              symbol
              presentation
              description
              displayUnit
              displayValue
              unit
              precision
              value
              valueMin
              valueMax
              valueZeroAllowed
              valueMinInclusive
              valueMaxInclusive
              values
              validationType
              validationMessage
              bomRelevant
            }
          }
          outputs {
            presentation
            properties {
              id
              symbol
              presentation
              description
              displayUnit
              displayValue
              unit
              precision
              value
              valueMin
              valueMax
              valueZeroAllowed
              valueMinInclusive
              valueMaxInclusive
              values
              validationType
              validationMessage
              bomRelevant
            }
          }
          outputsAcoustic {
            presentation
            properties {
              id
              symbol
              presentation
              description
              displayUnit
              displayValue
              unit
              precision
              value
              valueMin
              valueMax
              valueZeroAllowed
              valueMinInclusive
              valueMaxInclusive
              values
              validationType
              validationMessage
              bomRelevant
            }
          }
          availableStrategies {
            id
            presentation
          }
          currentStrategyId
          productType
          pluginName
          serie
          listViewConfiguration {
            columnTitles {
              key
              title
              subTitles {
                key
                title
                subTitles {
                  key
                  title
                  subTitles {
                    key
                    title
                  }
                }
              }
            }
            iterableParts {
              partKey
              options {
                optionKey
              }
            }
            targetPropertiesTitle
            targetProperties {
              id
              name
              valueMin
              valueMax
              unit
              defaultValue
              ignorable
            }
            accessories {
              title
              groups {
                title
                groupControlType
                controls {
                  id
                  title
                  boolValue
                  enabledBy
                  enabled
                  keyPresentation
                }
              }
            }
            attachments {
              title
              groups {
                title
                groupControlType
                controls {
                  id
                  title
                  boolValue
                  enabledBy
                  enabled
                  keyPresentation
                }
              }
            }
          }
        }
        productImageList {
          productImages {
            pimId
            text
            isReportImage
            typ
          }
        }
        specificationText {
          text
        }
      }
      errorCode
      errorMessage
      epfVersion {
        major
        minor
        revision
        build
      }
    }
  }
`);

export const createProductReport = graphql(`
  mutation createProductReport($input: SingleProductReportInput!) {
    createProductReport(input: $input) {
      base64Data
    }
  }
`);

export const createProductXBIMReport = graphql(`
  mutation createProductXBIMReport($input: SingleProductXBIMReportInput!) {
    createProductXBIMReport(input: $input) {
      base64Data
    }
  }
`);

export const createProduct3DModel = graphql(`
  mutation createProductXBIMReport($input: SingleProductXBIMReportInput!) {
    createProductXBIMReport(input: $input) {
      base64Data
    }
  }
`);

export const createLCAProductReportMut = graphql(`
  mutation createLCAProductReport($input: CreateLCAProductReportInput!) {
    createLCAProductReport(input: $input) {
      message
      jobId
      status
      url
    }
  }
`);
